<!--创建追踪记录-->
<template>
  <div class="root-container">
    <el-form label-position="center" ref="CuleRef" :model="param" :rules="rules"  label-width="140px">
      <el-form-item label="姓名:" >
        <el-input readonly=true v-model="info.childName" style="width: 270px"></el-input>
      </el-form-item>
      <el-form-item label="小名:" >
        <el-input readonly=true v-model="info.childPetName" style="width: 270px"></el-input>
      </el-form-item>
      <el-form-item label="手机号:" >
        <el-input readonly=true v-model="info.userPhone" style="width: 270px"></el-input>
      </el-form-item>
      <el-form-item label="意向级别:"   prop="intention">
        <el-select  v-model="param.intention" placeholder="请选择" @change="onChaneWork" style="width: 270px">
          <el-option
            v-for="item in intentions"
            :key="item.v"
            :label="item.des"
            :value="item.v">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="跟进人:"  prop="followUpWorkerId">
        <el-select  v-model="param.followUpWorkerId" placeholder="请选择" @change="onChaneWork" style="width: 270px">
          <el-option
            v-for="item in allWorker"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="跟进阶段:"  prop="followUpStage">
        <el-select  v-model="param.followUpStage" placeholder="请选择" @change="onChaneWork" style="width: 270px">
          <el-option
            v-for="item in followStages"
            :key="item.v"
            :label="item.des"
            :value="item.v">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="下一次跟进日期:">

        <el-date-picker style="width: 270px"
          v-model="param.nextFollowDay"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="备注:" >
        <el-input
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 20}"
          placeholder=""
          style="width: 450px"
          maxlength="200"
          show-word-limit
          v-model="param.remark">
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer-1" >
      <el-button style="background-color: #F14B39 ;color: white;" @click="onClickSure('CuleRef')">确认</el-button>
    </div>
  </div>
</template>

<style scoped>

</style>

<script>


  import {EAllFollowStage, EAllIntention} from "../../../utils/enumsUtil";
  import commonUtils from "../../../utils/commonUtils";
  import {createOneClueRecord} from "../../../api/MktClueManager";
  import messageUtils from "../../../utils/messageUtils";
  import globaldata from "../../../utils/globaldata";
  import timeUtils from "../../../utils/timeUtils";

  export default {
    name: 'CreateCule',
    props: {
      info:Object,
      allWorker:Array
    },
    data() {
      return {
        rules:{
          intention:[{required:true,message:"请选择意向级别",trigger:["blur",'change']}],
          followUpWorkerId:[{required:true,message:"请选择跟进人",trigger:["blur",'change']}],
          followUpStage:[{required:true,message:"请选择跟进阶段",trigger:["blur",'change']}],

        },
        intentions:[],//意向级别列表
        followStages:[],//跟进阶段列表

        param:{
          intention:'',
          followUpWorkerId:"",
          followUpStage:"",
          nextFollowDay:"",//下一次跟进日期
          remark:"",
        }

      }
    },
    created(){
      this.initData();

    },
    methods: {

      initData(){

        this.intentions = EAllIntention();
        this.followStages = EAllFollowStage();

      },
      onClickSure(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let   nextFollowDay = 0;
            if (commonUtils.isStringNull(this.param.nextFollowDay) == false){
              nextFollowDay = timeUtils.transDayInt(this.param.nextFollowDay)
            }
            let param = {
              storeFrontId:globaldata.getAdminStore().storeFrontId,
              childId:this.info.childId,
              userId:this.info.userId,
              intention:this.param.intention,
              followUpWorkerId:this.param.followUpWorkerId,
              followUpStage:this.param.followUpStage,
              nextFollowDay:nextFollowDay,
              remark:this.param.remark
            }
            const loading = this.myLoading();
            createOneClueRecord(param).then(response =>
            {
              loading.close();
              let data = response.data;
              if (commonUtils.isObjectNull(data)){
                return;
              }
              if (data == true){
                messageUtils.successMsg(this,response.message)
              }else {
                messageUtils.errorMsg(this,response.message)
              }
              this.$emit('onCreateSuccess')

            })

          }
        });
      }

    },


  }
</script>






// WEBPACK FOOTER //
// src/views/marketing-manager/components/CreateCule.vue